<template>
    <TabView v-model:activeIndex="activeIndex" class="z-0"  @tab-click="$emit('tabChange', activeIndex); setMinWidth();" >
    <!-- :pt="{root:{style:{'margin-bottom': '10px'}}}"> -->
        <TabPanel v-for="header, index in headers" :key=header :header="header" :disabled="inEditMode">
            <div class="flex">
                <div class="top-border-invisible"></div>
                <div class="top-border"></div>
            </div>
            <div class="pl-2 pr-2 h-full content">
                <slot :index="index" :header="header"></slot>
            </div>
        </TabPanel>
    </TabView>
</template>

<script lang="ts" setup>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import { ref, defineProps, defineEmits, onMounted, onUnmounted } from 'vue'

defineEmits(['tabChange'])
const props = defineProps(['headers', 'expandedActive', 'parentTabActive', 'tabIndex', 'inEditMode'])
let activeIndex = props.expandedActive !== undefined ? props.expandedActive : props.parentTabActive
let index = props.expandedActive == undefined ? 0 : props.parentTabActive
let minWidth = ref("85.3px")

onMounted(async () => {
    window.addEventListener("resize", setMinWidth);
    // setMinWidth()
})

onUnmounted(async () => {
    window.removeEventListener('resize', setMinWidth)
})

function setMinWidth() {
    var tabIndex = props.tabIndex ? props.tabIndex : index
    minWidth.value = document.getElementsByClassName("p-tabview-nav")[tabIndex].getBoundingClientRect().width.toString() + "px"
}

</script>

<style>
.p-tabview-nav .p-tabview-nav-link {
    border: #243045;
    border-style: solid;
    border-width: 0.15rem;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 3px 15px 6px;
    background-color: #243045;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    color: #ffffff;
    z-index: 1;
    box-shadow: 6.2px 24.5px #e5e7eb;
    margin: 0 0 -3px 3px;
}

.p-tabview-nav-container {
    width: calc(10% * v-bind('headers.length'));
    min-width: min-content;
    overflow-x: hidden;
}

.p-tabview-nav {
    display: grid;
    grid-template-columns: repeat(v-bind('headers.length'), auto)
}

/* Selected tab header */
.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
    background-color: inherit;
    color: #243045 !important;
    border-color: #e5e7eb;
}

li:nth-child(1) a {
    margin-left: 0px !important;
}

/* Tab content */
.p-tabview .p-tabview-panels {
    padding-top: 0px;
    padding-bottom: 0px;
    padding: 0px;
    border: #e5e7eb;
    border-style: solid;
    border-top: none;
    border-width: 0.15rem;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 5px;
    /* min-width: v-bind(minWidth); */
}

.top-border {
    border-top: #e5e7eb solid 2px;
    width: calc(100% - calc(10% * v-bind('headers.length')) + 5px);
    border-top-right-radius: 60px;
    border-bottom-left-radius: 30px;
    transform: translate(2.3px, -2px);
}

.top-border-invisible {
    width: calc(100% - (100% - calc(10% * v-bind('headers.length')) + 5px));
    min-width: calc(v-bind(minWidth) - 6.5px);
    border-top-right-radius: 20px;
    border-bottom-left-radius: 30px;
}
</style>
